import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Survey from './Survey';
import FinishedSurvey from './FinishedSurvey';
import LoadingItem from './LoadingItem';
import PageWrapper from './PageWrapper';
import { fetchSurveyData } from '../server';
import LoadingWrapper from './LoadingWrapper';

function SurveyPage() {
	const { surveyCode } = useParams();
	const [loading, setLoading] = useState(true);
	const [surveyData, setSurveyData] = useState([]);
	const [isCompleted, setIsCompleted] = useState(false);
	const [error, setError] = useState(null);
	const [schoolName, setSchoolName] = useState('');
	const [userName, setUserName] = useState('');

	useEffect(() => {
		const getSurveyData = async () => {
			if (!surveyCode) {
				setError('Survey token is not provided. This survey is not available.');
				setLoading(false);
				return;
			}

			try {
				// Call the API to get survey data based on the code
				const response = await fetchSurveyData(surveyCode);
				console.log(response);

				if (response.isCompleted) {
					setIsCompleted(true);
				} else if (response.surveyData) {
					// Ensure survey data is an array
					if (Array.isArray(response.surveyData)) {
						setSurveyData(response.surveyData);
					} else {
						console.error('Survey data is not an array:', response.surveyData);
						setError('The survey data format is incorrect. Please contact support.');
					}

					setSchoolName(response.schoolName || '');
					setUserName(response.contactName || '');
				} else {
					setError('Unable to retrieve survey data');
				}
			} catch (err) {
				setError('Error retrieving survey data');
				console.error('Error fetching survey data:', err);
			} finally {
				setLoading(false);
			}
		};

		getSurveyData();
	}, [surveyCode]);

	if (loading) {
		return <LoadingWrapper />;
	}

	if (error) {
		return (
			<PageWrapper title='Oops! Something happened...'>
				<div className='text-center'>
					<p>{error}</p>
					<p className='mt-[10px]'>Please check the survey code and try again.</p>
					<p className='mt-[20px]'>
						If you continue to experience issues, please contact support at:
						<br />
						<a href='mailto:help@alkalmahealth.com' className='font-bold text-[#153c4f]'>
							help@alkalmahealth.com
						</a>
					</p>
				</div>
			</PageWrapper>
		);
	}

	if (isCompleted) {
		return <FinishedSurvey surveyCode={surveyCode} />;
	}

	return (
		<PageWrapper title='AlkalmaUp Baseline Wellbeing Assessment'>
			<p>Welcome to the AlkalmaUp Baseline Wellbeing Assessment! </p>
			<br />
			<p>
				This brief assessment aims to understand your school's current position in its wellbeing journey, enabling us to provide tailored support to meet your specific needs. <br />
			</p>
			<p>&nbsp;</p>
			<p>Thank you for taking the time to complete this survey and thank you for choosing Alkalma!</p>
			<p>&nbsp;</p>

			{Array.isArray(surveyData) && surveyData.length > 0 ? (
				<Survey surveyData={surveyData} surveyCode={surveyCode} userName={userName} schoolName={schoolName} setIsCompleted={() => setIsCompleted(true)} />
			) : (
				<div className='text-center py-4'>
					<p className='text-red-500'>Survey data is not available or invalid.</p>
					<p>Please contact support for assistance.</p>
				</div>
			)}
		</PageWrapper>
	);
}

export default SurveyPage;
